import Logs from "../../../components/nut/users/Logs";

const Widget = () => {
  return (
    <div>
      logs
      <br />
      <Logs />
    </div>
  );
};

export default Widget;
